import { render, staticRenderFns } from "./SGoodsCate.vue?vue&type=template&id=73ea80ad&scoped=true"
import script from "./SGoodsCate.vue?vue&type=script&lang=js"
export * from "./SGoodsCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ea80ad",
  null
  
)

export default component.exports